import { SUPPORTED_LOCALES } from "~/lib/locale";

const PROTECTED_PREFIXES = [
  "/analytics",
  "/applications",
  "/cover-letters",
  "/dashboard",
  "/deep-match",
  "/feedback",
  "/help",
  "/interview-prep",
  "/jobs",
  "/keyword-optimizer",
  "/negotiation",
  "/onboarding",
  "/portal-scanner",
  "/referral",
  "/resumes",
  "/settings",
  "/story-bank",
  "/university/dashboard",
] as const;

// Mixed public/private sections need exact-path handling instead of prefix matches.
const PROTECTED_EXACT_PATHS = new Set([
  "/salary",
  "/salary/negotiate",
]);

function normalizePathname(pathname: string): string {
  if (!pathname) return "/";
  if (pathname.length > 1 && pathname.endsWith("/")) {
    return pathname.slice(0, -1);
  }
  return pathname;
}

export function stripLocalePrefix(pathname: string): { locale: string | null; pathname: string } {
  const normalizedPath = normalizePathname(pathname);

  for (const locale of SUPPORTED_LOCALES) {
    if (normalizedPath === `/${locale}`) {
      return { locale, pathname: "/" };
    }

    const prefix = `/${locale}/`;
    if (normalizedPath.startsWith(prefix)) {
      return {
        locale,
        pathname: normalizePathname(normalizedPath.slice(locale.length + 1)),
      };
    }
  }

  return { locale: null, pathname: normalizedPath };
}

export function isProtectedRoutePath(pathname: string): boolean {
  const { pathname: deLocalizedPath } = stripLocalePrefix(pathname);

  if (PROTECTED_EXACT_PATHS.has(deLocalizedPath)) {
    return true;
  }

  return PROTECTED_PREFIXES.some((prefix) =>
    deLocalizedPath === prefix || deLocalizedPath.startsWith(`${prefix}/`),
  );
}

export function getProtectedRouteLoginRedirect(pathname: string): string | null {
  const { locale, pathname: deLocalizedPath } = stripLocalePrefix(pathname);
  if (!isProtectedRoutePath(deLocalizedPath)) {
    return null;
  }

  return locale ? `/${locale}/auth/login` : "/auth/login";
}
